import axios from 'axios/index';
import React, {PureComponent} from 'react';

import {Classes, Overlay} from "@blueprintjs/core";
import toastr from 'toastr';
import {getCurrentUserId, getJwt} from '../../services/authService';
import http from '../../services/httpService';
import {Link} from "react-router-dom";

export default class WebPushCustomPostModal extends PureComponent {
    state = {
        overlayIsOpen: false,
        countPushSubscribers: this.props.countPushSubscribers
    };

    handleClose = () => {
        this.setState({
            overlayIsOpen: false
        })
        this.props.setSubsZero()
    };

    componentDidMount = () => {
        this.setState({
            overlayIsOpen: this.props.showModal,
        })
    }

    goToCampaignPerformance = () => {
        localStorage.removeItem('selected_main_type')
        this.props.handleClose()
        this.props.history.push('/my-campaigns/web-push')
    }

    goToCampaigns = () => {
        this.props.handleClose()
        this.props.history.push('/new')
    }

    componentDidUpdate = () => {
        if (this.state.overlayIsOpen !== this.props.showModal) {
            this.setState({
                overlayIsOpen: this.props.showModal
            })
        }
        if (this.state.countPushSubscribers !== this.props.countPushSubscribers) {
            this.setState({
                countPushSubscribers: this.props.countPushSubscribers
            })
        }
    }

    render() {
        return (
            <Overlay
                onClose={this.props.handleClose} className={Classes.OVERLAY_SCROLL_CONTAINER}
                isOpen={this.state.overlayIsOpen}
                style={{
                    display: 'flex',
                    flex: 1,
                    justifyContent: 'center',
                    alignItems: 'center',
                }}
            >
                <div className="modal-field"
                     style={{width: this.props.width || '60%', maxWidth: this.props.maxWidth || '100%'}}>
                    <p className="modal-close-button" onClick={() => {
                        this.props.handleClose()
                    }}><i className="fas fa-times"></i></p>
                    <div className="onboarding-panel post-reach">


                        {this.props.error !== '' ?
                            <React.Fragment>
                                <h2 className='text-center m-lg-b m-lg-t'>
                                    {this.props.error}
                                </h2>
                            </React.Fragment>
                            :
                            <React.Fragment>
                                <p className=" modal-title text-center m-m-b" style={{fontSize: "30px"}}>
                                    Sending attempted to:
                                </p>

                                {this.state.countPushSubscribers > 0 ?
                                    <React.Fragment>
                                        <div className="section-content text-center ">
                                            <p className="letter text-bold">
                                                {this.state.countPushSubscribers}
                                                <br></br>
                                                <span>{this.state.countPushSubscribers === 1 ? 'Subscriber' : 'Subscribers'}</span>
                                            </p>
                                        </div>
                                        <div className="row reach-modal-performance-msg">
                                            Please visit <Link onClick={this.props.onClickAway}
                                                               to='/my-campaigns/web-push'>campaign
                                            performance</Link> page for detailed
                                            analytics of this campaign.
                                        </div>
                                    </React.Fragment>
                                    :
                                    <div className="section-content text-center no-subscribers-reach m-lg-t">

                                        There are no subscribers <br></br> matching this criteria!

                                    </div>
                                }
                            </React.Fragment>

                        }
                    </div>
                    <div className="m-lg-t flex-direction-row justify-content-space">
                        <button className='btn-white'
                                onClick={this.goToCampaignPerformance}>
                            Go to My Campaigns
                        </button>
                        <button className='btn-action'
                                onClick={this.goToCampaigns}>
                            Start a new campaign
                        </button>
                    </div>
                </div>
            </Overlay>
        )
    }
}